/* eslint-disable no-restricted-imports */
/* jshint asi:true */

import React, { useEffect, useState } from 'react';
import Helmet from "react-helmet"
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { Link,useHistory } from 'react-router-dom'
import alertService from '../../../_services/alertservice';
// alertService.alert({ message :"Hi", type : 'error'  });
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { useDispatch } from 'react-redux';
import { logout } from '../../../../actions/auth';


function InterviewAddFitment() {
  var ModuleId;

  const [fitmentParameters, setFitmentParameters] = useState([]);
  const [selectedId, SetSelectedCategoryId] = useState(0);
  const [expectedScore, SetExpectedScore] = useState('1');    

  const filter = createFilterOptions();

  const get_fitments = (setDefault) => {
    const token = localStorage.getItem('x-access-token');
    fetch(`${process.env.REACT_APP_API_BASE_URL}api/v1/interview/fitments?page=1&limit=1000`, {

      method: 'GET',
      headers: {
        'content-type': 'application/json',
        'x-access-token': token
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status == true) {
          setFitmentParameters(res.data);          
        }
        else if(res.sessionExpired){
          alertService.alert({ message :res.message, type : 'error'  });
          logoutMethod();
        }
        else {
        }
      })
      .catch(() => {
      });
  }


  const [selectedParentCategory, setSelectedParentCategory] = useState("")
  var newparentid;
    

  const [lodingCategory,SetlodingCategory]=useState(false);
    const add_Fitment = (go_to_list=null) => {
    // var CatName = document.getElementById("category").value;
    var ParameterName = document.getElementById("parameter-name-id-feild").value
    if (ParameterName) {
      const reqData = {
          "parameterName": ParameterName,
          "expectedScore": 5
      }
      const token = localStorage.getItem('x-access-token');

        fetch(`${process.env.REACT_APP_API_BASE_URL}api/v1/interview/add_fitment`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'x-access-token': token

        },
        body: JSON.stringify(reqData)
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.status == true) {
            if(go_to_list == 1){
              history.push('/interview/view-fitment');              
            }
            SetlodingCategory(false);
            alertService.alert({ message: res.message, type: 'success' });
            get_fitments(true)  
            document.getElementById("parameter-name-id-feild").value = ''
            SetExpectedScore('1')     
         
          }else if(res.sessionExpired){
            alertService.alert({ message :res.message, type : 'error'  });
            logoutMethod();
            SetlodingCategory(false);

          }
          else {
            alertService.alert({ message: res.message, type: 'error' });

            //  alert(res.message);
            SetlodingCategory(false);

          }
        })
        .catch(() => {
          SetlodingCategory(false);
        });
    }
    else {
      alertService.alert({ message: "Please Enter Parameter Name", type: 'warning' });
      SetlodingCategory(false);
    }
  }

  const deleteFitment = () => {
    const token = localStorage.getItem('x-access-token');
      fetch(`${process.env.REACT_APP_API_BASE_URL}api/v1/interview/delete_fitment/` + idFitment , {
      method: 'DELETE',
      headers: {
        'content-type': 'application/json',
        'x-access-token': token
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status == true) {
          setModalShow3(false);
          alertService.alert({ message: res.message, type: 'success' });
          get_fitments(selectedId);

        }else if(res.sessionExpired){
          alertService.alert({ message :res.message, type : 'error'  });
          logoutMethod();
        }
        else {
          setModalShow3(false);
          alertService.alert({ message: res.message, type: 'error' });
        }
      })
      .catch(() => {
      });
  }



  useEffect(() => {
    let mounted = true;
    get_fitments();
    return () => mounted = false;
  }, [])

   
    const ExpectedScores = ['1', '2', '3', '4', '5']
    const handleSelectChange = (value, e) => {
        if (value) {
            SetExpectedScore(value);
        }
    }


  const [modalShow3, setModalShow3] = React.useState(false);

  function DeleteConfirmationModal(props) {
    return (
    <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Modal.Title id="contained-modal-title-vcenter text-center">
            <p className="text-center">
            <img alt="logo" className="brand-dim" src="/media/logos/UPDATED_VRekruit _Logo.png" />
              </p>
            <p className="text-dark text-center pt-3"> Are you sure want to delete this fitment parameter ?</p>
          </Modal.Title>
        </Modal.Body>
        <Modal.Title className="d-flex justify-content-center align-items-center pb-5" >
        <p className="text-center">

                    <Button className="btn btn-theme text-white btn-lg mr-5  pl-5 pr-5 pt-3 pb-3" style={{ "minWidth": "100px" }} onClick={() => deleteFitment(idFitment)}> Yes </Button>
       <Button className="btn btn-theme-green btn-lg pl-5 pr-5 pt-3 pb-3 bg-theme-green" style={{"minWidth": "100px"}}  onClick={props.onHide}>No</Button> 
       </p>
        </Modal.Title>
      </Modal>
    );
  }
    const [value, setParentCatValue] = React.useState(null);
    const [inputParentCatValue, setInputValue] = React.useState('');
const [idFitment,SetDeleteId]= useState();
    const history = useHistory()

    const CanDeleteFitment = (delIdvalue) => {
    SetDeleteId(delIdvalue)
    const token = localStorage.getItem('x-access-token');
        fetch(`${process.env.REACT_APP_API_BASE_URL}api/v1/company/edit_delete_premission?module=interview_fitment&moduleId=` + delIdvalue, {
      method: 'Get',
      headers: {
        'content-type': 'application/json',
        'x-access-token': token
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === true) {
          if(res.data.canDelete) {
            setModalShow3(true);
          }
          if(res.data.deleteMessage)
            {
             alertService.alert({ message: res.data.deleteMessage, type: 'error' });
            }
           else if(res.sessionExpired){
            setModalShow3(false);
            alertService.alert({ message :res.message, type : 'error'  });
            logoutMethod();
          }
        }
        else {
          alertService.alert({ message: res.message, type: 'error' });
          setModalShow3(false);
        }
      })
  }
  const [delId, SetDeleteSubCategoryId] = useState("")
  const deleteSubCategoryModal = (value) => {
    setModalShow3(true);
    SetDeleteSubCategoryId(value);
  }
  const dispatch = useDispatch();
  const logoutMethod = () => {
    dispatch(logout());
    history.push('/auth/signin');
};

  return <>
    <Helmet>
      <title> VRekruit | Add Fitment Parameter</title>
    </Helmet>

    {/* subeader */}
    <div id="kt_subheader" className="subheader py-2 py-lg-4    subheader-solid">
      <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
        <div className="d-flex align-items-center flex-wrap mr-1">
          <div className="d-flex align-items-baseline mr-5">
            <h3 className="text-dark font-weight-bold my-2 mr-5 f-w-600">Interview Management</h3></div>
        </div>
        <div className="d-flex align-items-center" />
      </div>
    </div>
    {/* subeader */}


    <Col className="bg-white" >
      <Row className="bg-white pt-4 pb-4 align-items-center sticky-header">
        <Col md={6} sm={12} offset={4} className="pr-3 pl-3">
          <div>
            <div className="d-flex flex-grow-1 align-items-center  justify-content-start   rounded">
              <div>
                <h5 className="font-weight-bold f-w-600 pl-5" > Assessment Management &nbsp;&nbsp; {'>'} &nbsp;&nbsp; Add Fitment Parameters </h5>
              </div>
            </div>
          </div>
        </Col>
        <Col md={6} sm={12} offset={4} className="pr-3 pl-3">
          <div>
            <div className="d-flex flex-grow-1 align-items-center justify-content-end rounded mt-1">
              <div className="text-muted d-block">
              <Button  onClick={(e) => add_Fitment(1)} type="button" 
                      className={`btn btn-theme-green btn-lg mr-5 mt-2 mb-0` }>
                      Save
               </Button>
                <Link to="/interview/view-fitment" type="button" className="btn btn-theme btn-lg mr-5  text-white">
                  Close
                </Link>
              </div>
            </div>
          </div>
        </Col>
        <Col md={12} sm={12} className="separator separator-solid  mt-5"></Col>
      </Row>

     <Col className="Content-custom-padding pt-10">
        <Form>
          <Row className="mt-5">
            <Form.Label column sm="2">
              Fitment Parameter Name
            </Form.Label>
            <Col sm="6">
              <Form.Group className="autocomplete " as={Col} >
                <Form.Control placeholder="" id="parameter-name-id-feild" />
              </Form.Group>
                      </Col>
         { /*    <Col sm="3">
                          <Form.Group className="autocomplete expectedScoreClass" as={Col} >
                              <Autocomplete size="small"
                                  id="roles-titles"
                                  options={ExpectedScores}
                                  renderInput={(params) => (
                                      <TextField {...params} label="Expected Score" margin="normal" variant="outlined" />
                                  )}
                                  value={expectedScore}
                                  getOptionLabel={
                                      (options) => options}
                                  onChange={(event, newValue) => {
                                      handleSelectChange(newValue, event);
                                  }}
                              />
                    
                </Form.Group>
                                </Col> */ }
            <Form.Label column sm="2" className= {`text-theme-green mt-1 pt-0 ${lodingCategory ? "p-none no-drop":"" }`}>
              <span className="c-p" 
              >
                <img src="/media/VRekruitIcons/addmore.svg" className="c-p" width="24" onClick={add_Fitment} />
                {/* <i className="fa fa-plus-circle text-theme-green mr-3 c-p" onClick={() => setModalShow(true)}></i> */}
              </span>
            </Form.Label>
          </Row>
          <Row controlId="formPlaintextPassword" style={{ paddingBottom: "200px" }}>
            
            {fitmentParameters.map
              (x =>
                <>
                      <Form.Label column sm="2">
                          &nbsp;
                  </Form.Label>
                  <Col sm="6">
                    <Form.Group as={Col} >
                    <Form.Control value={x.parameterName} readOnly />
                </Form.Group>
                </Col>
                {/* <Col sm="3">
                    <Form.Group as={Col} >
                        <Form.Control value={x.expectedScore} readOnly />
                    </Form.Group>
              </Col> */ }
                  <Form.Label column sm="2" className="text-theme-green">
                    <span className="c-p">
                      <img src="/media/VRekruitIcons/delete.svg" className="c-p" data-id={x.id} width="24"
                        onClick={() => CanDeleteFitment(x.id)}
                        title="Delete" alt="Delete" 

                      />

                    </span>
                      </Form.Label>
                      <Form.Label column sm="2">
                          &nbsp;
                  </Form.Label>
                </>)}
          </Row>
          <DeleteConfirmationModal show={modalShow3} onHide={() => setModalShow3(false)} />
        </Form>
      </Col>
    </Col>
  </>;
}

export default InterviewAddFitment;